import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Sticky } from "../../basic/sticky";
import { Header } from "../header";
import { HeaderSearch } from "../header-search";
import { CtaWrapper, LogoWrapper, SecondaryMenu, DefaultMenu, Login, Monogram } from "../header-helper-components";
import { Sidebar } from "../sidebar";
import { accessCheck } from "../../../../isomorphic/utils";
import { DOUBLE_LAYER_ROOT_MARGIN } from "../../../constants";

import "./header-three.m.css";

const HeaderThree = props => {
  const isSearchFormVisible = get(props, ["header", "isSearchFormVisible"]);

  return (
    <Sticky rootMargin={DOUBLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="layer-1">
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon-mobile" />
          </div>
          <div styleName="cta">
            <CtaWrapper {...props} />
          </div>
          <div styleName="logo">
            <LogoWrapper {...props} />
          </div>
          <div styleName="secondary-menu">
            <SecondaryMenu {...props} customCssClasses="header-three-secondary" />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon-mobile" />
          </div>
          {accessCheck(props.enableSSO) && (
            <div styleName="login">
              <Login {...props} />
            </div>
          )}
        </div>
        <div styleName={`layer-2 ${isSearchFormVisible ? "hide-search-form" : ""}`}>
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" />
          </div>
          <div styleName="monogram">
            <Monogram {...props} />
          </div>
          <div styleName="default-menu">
            <DefaultMenu {...props} />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};

HeaderThree.propTypes = {
  header: PropTypes.shape({
    isSearchFormVisible: PropTypes.bool
  }),
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool
};

const HeaderTemplate = (showHeaderRowOnly = false) => (
  <Header renderTemplate={HeaderThree} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
